import { UrlProvider } from "../api/UrlProvider";

export function getStockPageSectionTriggerUrl({
  sectionOpen,
  locale,
  market,
  ticker,
  slug
}) {
  const urlProviderVariables = {
    locale,
    marketId: market,
    stockId: ticker.toLowerCase()
  };

  if (sectionOpen) {
    return UrlProvider.getUrl("fe.stockPage", urlProviderVariables);
  }

  return UrlProvider.getUrl("fe.stockPageSection", {
    ...urlProviderVariables,
    section: slug
  });
}
